import { createContext } from 'react'

export interface HValidation {
  history: string[]
  setHistory: (data: string[]) => void
  back: (fallbackRoute?: string) => void
}

export const HistoryContext = createContext<HValidation>({} as HValidation)
